<template>
  <div>
    <div class="caption">{{ $t('history') }}</div>
    <v-btn outline small class="mx-0" @click="isShow = true">
      <v-icon small class="mr-2">history</v-icon>
      <span>{{ $t('history') }}</span>
    </v-btn>

    <v-dialog v-model="isShow" scrollable max-width="800px">
      <v-card>
        <v-card-title>
          <span>{{ $t('history') }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="isShow = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="history"
          :pagination.sync="pagination"
          :total-items="total"
          :loading="loading"
        >
          <template #items="props">
            <tr>
              <td>{{ props.item.adminid }}</td>
              <td>{{ props.item.action }}</td>
              <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { handleApiError } from '@/api/util'
import intentApi from '@/api/intent'
import { mapGetters } from 'vuex'
export default {
  props: {
    intentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isShow: false,
      history: [],
      headers: [
        { text: 'Admin', value: 'adminid', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
        { text: 'Timestamp', value: 'timestamp', sortable: false }
      ],
      total: 0,
      pagination: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    isShow(val) {
      if (val) {
        this.getHistory()
      }
    },
    pagination: {
      handler() {
        this.getHistory()
      },
      deep: true
    }
  },
  methods: {
    async getHistory() {
      this.loading = true
      try {
        const { page, rowsPerPage } = this.pagination
        const response = await intentApi.getIntentHistory({
          params: {
            id: this.intentId,
            limit: rowsPerPage,
            offset: (page - 1) * rowsPerPage,
            page_id: this.selectedBot.pageid
          }
        })

        if (response.status == 200) {
          this.history = response.data.data || []
          this.total = response.data.total || 0
        } else {
          this.history = []
          this.total = 0
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentHistory.vue